import { profileApiSlice } from '@src/api';
import { Permission } from '@src/api/types';
import React, { FC, memo, ReactElement } from 'react';

type RoleKeeperProps = {
  permissions?: Permission[] | Permission;
  action?: 'disabled' | 'hide';
  children: ReactElement;
  include?: boolean;
};

/**
 * @param action скрывает или делает не активным элемент
 * @param permissions строка или массив ролей
 * @param include true значит должен включать все роли, по умолчанию false проверяет что есть хотя-бы одна роль
 */
export const RoleKeeper: FC<RoleKeeperProps> = memo(
  ({ children, action = 'hide', permissions, include = false, ...rest }) => {
    // если не передавать роли то возвращается Дочерний компонент
    if (!permissions) return React.cloneElement(children, rest);

    const { data: profile } = profileApiSlice.useGetProfileQuery('');
    if (!profile) return null;

    let forbidden: boolean;

    if (include && typeof permissions !== 'string') {
      forbidden = !permissions.every(currentRole => profile.permissions.includes(currentRole));
    } else {
      forbidden =
        typeof permissions === 'string'
          ? !profile.permissions.includes(permissions)
          : !permissions.some(currentRole => profile.permissions.includes(currentRole));
    }

    if (forbidden && action === 'hide') return null;
    const props = { ...rest };
    if (forbidden && action === 'disabled') {
      props[action] = true;
    }
    return React.cloneElement(children, props);
  },
);

RoleKeeper.displayName = 'RoleKeeper';
